import { USER_AGENT } from "./version-Dl3bNTAd.js";
import { createAnthropic } from "@ai-sdk/anthropic";

//#region src/internal/agents/anthropic-provider.ts
const DEFAULT_ANTHROPIC_MODEL = "claude-sonnet-4-5";
let configuredBaseUrl;
/**
* Configure the Anthropic base URL (CLI flag only, not environment variable).
* This must be called explicitly - it cannot be set via environment variables for security.
*/
function setAnthropicBaseUrl(baseUrl) {
	configuredBaseUrl = baseUrl;
}
/**
* Retrieve an Anthropic language model configured from environment variables and explicit config.
*
* Configuration:
* - ANTHROPIC_API_KEY: API key for authentication (required)
* - ANTHROPIC_MODEL: Model to use (default: "claude-sonnet-4-5") - env var OK
* - Base URL: Must be set via setAnthropicBaseUrl() - NOT from env vars (security risk)
*/
function getAnthropicModel(model) {
	const defaultModel = process.env.ANTHROPIC_MODEL || DEFAULT_ANTHROPIC_MODEL;
	const factory = createAnthropic({
		...configuredBaseUrl && { baseURL: configuredBaseUrl },
		headers: { "User-Agent": USER_AGENT }
	});
	return factory(model ?? defaultModel);
}

//#endregion
export { getAnthropicModel, setAnthropicBaseUrl };
//# sourceMappingURL=anthropic-provider-CRd6GA4E.js.map